module.exports = __webpack_public_path__ + "static/img/footer.png";